import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { textConvert } from "../../../../../components/language/dropdown/textconvert";

function CaddieSearch({
  search,
  setSearch,
  openSearch,
  setOpenSearch,
  setTriggerSearch,
  setPage,
  setHasMore,
  searchInput,
  setSearchInput,
}) {
  const { t } = useTranslation();

  const inputRef = useRef(null);

  // const handleOnTypeSearch = (e) => {
  //   const value = e.target.value;

  //   if (value.trim() === "") {
  //     setSearch({
  //       ...search,
  //       text: {
  //         state: false,
  //         value: "",
  //       },
  //     });
  //   } else {
  //     setSearch({
  //       ...search,
  //       text: {
  //         state: true,
  //         value: value,
  //       },
  //     });
  //   }
  // };

  // const handleKeyDown = (e) => {
  //   const value = e.target.value;
  //   if (e.key === "Enter") {
  //     setOpenSearch(false);
  //     triggerSearch(value);
  //   }
  // };

  // const triggerSearch = (value) => {
  //   console.log(value);
  //   setSearch({
  //     ...search,
  //     text: {
  //       state: true,
  //       value: value,
  //     },
  //   });

  //   if (inputRef.current) {
  //     inputRef.current.value = "";
  //   }
  // };


  const handleProviceSelect = (province) => {
    setOpenSearch(false);
    setSearch({
      ...search,
      province: {
        state: true,
        value: province,
      },
    });
    setOpenSearch(false);
  };

  const handleOnTypeSearch = (e) => {
    const value = e.target.value;
    if (value.trim() === "") {
      setSearchInput("");

      setTriggerSearch(false);
    } else {
      setSearchInput(value);
    }
  };

  const handleKeyDown = (e) => {
    setPage(0);
    setHasMore(true);
    const value = e.target.value;
    if (e.key === "Enter") {
      setOpenSearch(false);
      triggerSearch(value);
      setTriggerSearch(true);
    }
  };

  const handleSearch = () => {
    setPage(0);
    setHasMore(true);
    const value = inputRef.current.value; // ดึงค่าจาก input
    setOpenSearch(false);
    triggerSearch(value); // ส่งค่าจาก input ไปยัง triggerSearch
    setTriggerSearch(true);
  };

  const triggerSearch = (value) => {
    console.log(value);
    setSearch({
      ...search,
      text: {
        state: true,
        value: searchInput,
      },
    });

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleNearMe = (nearMe) => {
    setOpenSearch(false);
    setSearch({
      ...search,
      nearMe: {
        state: true,
      },
    });
    setOpenSearch(false);
  };

  return (
    <>
      <Dropdown show={openSearch} onToggle={() => setOpenSearch(!openSearch)}>
        <Dropdown.Toggle as="div">
          {/* <div className="search-form-2 flex-grow-1">
            <i className="ti-search font-xss"></i>
            <input
              type="text"
              className="form-control text-grey-500 mb-0 bg-greylight theme-dark-bg border-0"
              placeholder={t(textConvert("Search here"))}
              onChange={handleOnTypeSearch} // ค้นหาทันทีที่พิมพ์
              onKeyDown={handleKeyDown} // ค้นหาเมื่อกด Enter
              ref={inputRef}
              value={search.text.value}
            />
          </div> */}

          {/* <div className="search-form-2 flex-grow-1">
            <i className="ti-search font-xss" onClick={handleSearch}></i>
            <input
              type="text"
              className="form-control text-grey-500 mb-0 bg-greylight theme-dark-bg border-0"
              placeholder={t(textConvert("search here"))}
              onChange={handleOnTypeSearch} // ค้นหาทันทีที่พิมพ์
              onKeyDown={handleKeyDown} // ค้นหาเมื่อกด Enter
              ref={inputRef}
              value={searchInput}
            />
          </div> */}

          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder={t(textConvert("search here"))}
              onChange={handleOnTypeSearch} // ค้นหาทันทีที่พิมพ์
              onKeyDown={handleKeyDown} // ค้นหาเมื่อกด Enter
              onFocus={() => setOpenSearch(true)}
              onBlur={() => setOpenSearch(false)}
              ref={inputRef}
              value={searchInput}
            />
            <div class="input-group-append">
              <button className="btn btn-light h-100" onClick={handleSearch}>
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
        </Dropdown.Toggle>
      </Dropdown>
    </>
  );
}

export default CaddieSearch;
